// FTEDN Creator — Vote Results (bar chart view)
import { calculateResults, CATEGORY_ICONS } from './voting.helpers';
import type { VoteCard } from '../../stores/voting.store';
import './VotingPage.css';

interface VoteResultsProps {
  cards: VoteCard[];
}

export function VoteResults({ cards }: VoteResultsProps) {
  // Sort by votes descending
  const sorted = [...cards].sort((a, b) => b.votes - a.votes);

  return (
    <div className="vote-results">
      <h2 className="results-title">Community Results</h2>
      <div className="results-list">
        {sorted.map(card => {
          const results = calculateResults(card.votes, card.votes); // All "for" since we only track upvotes
          const maxVotes = sorted[0]?.votes || 1;
          const barWidth = Math.max(5, (card.votes / maxVotes) * 100);

          return (
            <div key={card.id} className={`result-row ${card.hot ? 'result-hot' : ''}`}>
              <div className="result-info">
                <span className="result-category">
                  {CATEGORY_ICONS[card.category] || '📋'}
                </span>
                <div className="result-text">
                  <strong>{card.title}</strong>
                  <span className="result-desc">{card.description}</span>
                </div>
              </div>
              <div className="result-bar-container">
                <div className="result-bar" style={{ width: `${barWidth}%` }}>
                  <span className="result-count">{card.votes}</span>
                </div>
              </div>
              {card.hot && <span className="result-hot-tag">🔥</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
